import React, { FC } from 'react'

import { WarningModal } from 'components/WarningModal'

type WarningProps = {
  confirmAction: () => void
  updateParentState: () => void
  text?: string
}

export const TemplateDeletionWarningModal: FC<WarningProps> = ({
  confirmAction,
  updateParentState,
  text
}) => {
  const buttonProps = [
    { text: 'Cancel' },
    { text: 'Confirm', action: confirmAction },
  ]

  const warningText = text || `You are about to permanently delete a template document. All
  documents derived from this template will also be destroyed. Do you want to continue?`

  return (
    <WarningModal
      warningText={warningText}
      modalButtonProps={buttonProps}
      onSelection={updateParentState}
    />
  )
}
